import { OrganizerUser } from 'modules/roles-manager/domain/interfaces/organizer-user';
import roleUsers, { CreateUserPayload } from 'modules/roles-manager/domain/resources/role-users';
import { useUsersPagesCache } from 'modules/roles-manager/ui/hooks/use-roles-manager-provider';
import { useMutation, useQueryClient } from 'react-query';

export function useCreateUser(tournamentId?: number) {
  const queryClient = useQueryClient();
  const { resetPagesCache } = useUsersPagesCache();

  return useMutation<OrganizerUser, unknown, CreateUserPayload>(
    (payload) => {
      if (!tournamentId) throw new Error('No tournamentId');
      return roleUsers.createUser(tournamentId, payload);
    },
    {
      onSuccess: () => {
        const queries = queryClient.getQueryCache().findAll('roleUsers');

        // 1. Находим максимальный offset, где в кэше реально есть данные
        let lastOffsetWithData: number | null = null;

        queries.forEach((query) => {
          const key = query.queryKey as any[];
          if (!Array.isArray(key)) return;
          if (key[0] !== 'roleUsers') return;
          if (key[1] !== tournamentId) return;

          const pageParams = key[3] as { limit?: number; offset?: number } | undefined;
          const offset = pageParams?.offset;
          if (typeof offset !== 'number') return;

          const data = queryClient.getQueryData<OrganizerUser[]>(key);
          if (!data || data.length === 0) return;

          if (lastOffsetWithData === null || offset > lastOffsetWithData) {
            lastOffsetWithData = offset;
          }
        });

        // 2. Инвалидируем только "хвост": все offset >= lastOffsetWithData
        if (lastOffsetWithData !== null) {
          queryClient.invalidateQueries({
            predicate: (q) => {
              const key = q.queryKey as any[];
              if (!Array.isArray(key)) return false;
              if (key[0] !== 'roleUsers') return false;
              if (key[1] !== tournamentId) return false;

              const pageParams = key[3] as { limit?: number; offset?: number } | undefined;
              const offset = pageParams?.offset;
              return typeof offset === 'number' && offset >= lastOffsetWithData!;
            },
          });
        }

        // если ещё нужно — чистим свой pagesCache
        resetPagesCache();
      },
    },
  );
}

export default useCreateUser;
